import { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';

const NAV_LINKS = [
  { href: '#results', label: '도입 효과' },
  { href: '#features', label: '서비스 소개' },
  { href: '#integration', label: 'POS 연동' },
  { href: '#pricing', label: '요금제' },
  { href: '#reviews', label: '고객 후기' },
  { href: '#faq', label: '자주 묻는 질문' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'backdrop-blur-xl bg-white/90 border-b border-neutral-200/60 shadow-sm'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-[72px]">
          <a href="#" className="flex items-center">
            <img
              src={scrolled ? '/landing/logo-full.png' : '/landing/logo-white.png'}
              alt="와우오더"
              className="h-7 w-auto transition-opacity duration-300"
            />
          </a>

          <div className={`hidden md:flex items-center gap-8 text-sm font-medium ${
            scrolled ? 'text-neutral-500' : 'text-white/70'
          }`}>
            {NAV_LINKS.map((l) => (
              <button
                key={l.href}
                onClick={() => scrollTo(l.href)}
                className={`transition-colors duration-300 ${
                  scrolled ? 'hover:text-neutral-900' : 'hover:text-white'
                }`}
              >
                {l.label}
              </button>
            ))}
          </div>

          <a
            href="tel:1644-6827"
            className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 bg-brand-400 text-neutral-900 text-sm font-semibold rounded-full hover:bg-brand-500 transition-colors duration-300"
          >
            <Icon icon="solar:phone-bold" className="text-base" />
            1644-6827
          </a>

          <button
            onClick={() => setOpen(!open)}
            className={`md:hidden p-2 transition-colors ${scrolled ? 'text-neutral-700' : 'text-white'}`}
          >
            <Icon
              icon={open ? 'solar:close-circle-linear' : 'solar:hamburger-menu-linear'}
              className="text-2xl"
            />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ${
          open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        } ${scrolled ? 'bg-white border-t border-neutral-200/60' : 'bg-neutral-950/95 backdrop-blur-xl'}`}
      >
        <div className="px-6 py-4 space-y-1">
          {NAV_LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className={`block w-full text-left text-sm font-medium py-2.5 transition-colors ${
                scrolled ? 'text-neutral-600 hover:text-neutral-900' : 'text-white/70 hover:text-white'
              }`}
            >
              {l.label}
            </button>
          ))}
          <a
            href="tel:1644-6827"
            className="block w-full text-sm font-semibold text-neutral-900 bg-brand-400 rounded-full px-5 py-2.5 text-center mt-3 hover:bg-brand-500 transition-colors"
          >
            전화 상담 1644-6827
          </a>
        </div>
      </div>
    </nav>
  );
}
